import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _permissionsInfo: {
    notification: "PermissionStatus.denied",
    camera: "PermissionStatus.denied",
  },
  _is_new_device: false,
  _app_update_modal: false,
  _app_update: null, // { appVersion, userMsg, forceUpdateYn }
};

export const mutations = {
  setPermissionsInfo(state, { notification, camera }) {
    state._permissionsInfo = { notification, camera };
  },
  setIsNewDevice(state, payload) {
    state._is_new_device = payload;
  },
  setAppUpdateModal(state, payload) {
    state._app_update_modal = payload;
  },
  setAppUpdate(state, payload) {
    state._app_update = payload;
    window.console.log("setAppUpdateModal", payload);
    if (payload?.forceUpdateYn === true) {
      state._app_update_modal = true;
    }
  },
};

export const actions = {
  async acSetPermissionsInfo({ commit, state }, { notification, camera }) {
    try {
      commit("setPermissionsInfo", { notification, camera });
      window.console.log(
        "SET PERMISSIONS INFO: ",
        JSON.stringify(state._permissionsInfo)
      );
    } catch (error) {
      return null;
    }
  },
  async acGetAppUpdate({ commit }, { device_push_token }) {
    const url = `/api/v1/settings/app-update`;
    try {
      const result = await api.post(url, { device_push_token });
      if (result?.data?.code === 0) {
        commit("setAppUpdate", result.data.data);
        return true;
      } else {
        commit("setAppUpdate", null);
        return false;
      }
    } catch (err) {
      commit("setAppUpdate", null);
      return false;
    }
  },
  async acRejectAppUpdate(
    { commit },
    { app_version, target_app_version, device_push_token }
  ) {
    const url = `/api/v1/settings/app-update/reject`;
    try {
      const result = await api.post(url, {
        app_version,
        target_app_version,
        device_push_token,
      });
      if (result?.data?.code === 0) {
        commit("setAppUpdateModal", false);
        return true;
      } else {
        commit("setAppUpdateModal", false);
        return false;
      }
    } catch (err) {
      commit("setAppUpdateModal", false);
      return false;
    }
  },
  async acGetIsNewDevice({ commit }, { device_push_token }) {
    const url = `/api/v1/settings/new-device`;
    try {
      const result = await api.post(url, { device_push_token });
      // window.console.log("acGetIsNewDevice result: ", JSON.stringify(result));
      if (result?.data?.code !== 0) {
        return false;
      }
      const isNewDevice = result?.data?.data?.is_new_device === true;
      commit("setIsNewDevice", isNewDevice);
      return isNewDevice;
    } catch (err) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
